import React from "react";
import { useTranslation } from "react-i18next";
import ReferenceListPage from "../components/ReferenceListPage";
import { actionTypesAPI } from "../services/api";
import { PERMISSIONS } from "../utils/permissions";

const ActionTypesPage = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <ReferenceListPage
      title={t("sidebar.actionTypes")}
      api={actionTypesAPI}
      requiredPermission={PERMISSIONS.MANAGE_ACTION_TYPES}
      onNavigate={onNavigate}
      columns={[
        { field: "action_type_id", label: "#" },
        { field: "name_ar", label: t("referencePages.nameAr") },
        { field: "name_en", label: t("referencePages.nameEn") },
        { field: "sort_order", label: t("actionTypes.sortOrder") },
        {
          field: "is_active",
          label: t("referencePages.active"),
          render: (item) =>
            item.is_active ? t("referencePages.yes") : t("referencePages.no"),
        },
      ]}
      formFields={[
        {
          name: "name_ar",
          label: t("referencePages.nameAr"),
          required: true,
        },
        {
          name: "name_en",
          label: t("referencePages.nameEn"),
          required: true,
        },
        {
          name: "sort_order",
          label: t("actionTypes.sortOrder"),
          type: "number",
          defaultValue: 0,
        },
        {
          name: "is_active",
          label: t("referencePages.active"),
          type: "boolean",
          defaultValue: true,
        },
      ]}
    />
  );
};

export default ActionTypesPage;
